import { createContext, useContext, ReactNode } from 'react';

interface DashboardContextType {
  dashboardData: any;
  isLoading: boolean;
  error: Error | null;
  isOverlayOpen: boolean;
  setIsOverlayOpen: (open: boolean) => void;
}

const DashboardContext = createContext<DashboardContextType>({
  dashboardData: null,
  isLoading: false,
  error: null,
  isOverlayOpen: false,
  setIsOverlayOpen: () => {},
});

export const useDashboardContext = () => useContext(DashboardContext);

interface DashboardProviderProps {
  children: ReactNode;
  dashboardData: any;
  isLoading: boolean;
  error: Error | null;
  isOverlayOpen: boolean;
  setIsOverlayOpen: (open: boolean) => void;
}

export const DashboardProvider = ({
  children,
  dashboardData,
  isLoading,
  error,
  isOverlayOpen,
  setIsOverlayOpen,
}: DashboardProviderProps) => {
  return (
    <DashboardContext.Provider value={{ dashboardData, isLoading, error, isOverlayOpen, setIsOverlayOpen }}>
      {children}
    </DashboardContext.Provider>
  );
}; 